import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable, { ColumnDescription } from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import Swal from 'sweetalert2'
import moment from 'moment';
import OutwardLogService from '../../services/outwardlog.service';
import Outcontainerheader from './Outcontainerheader';
import OutwardDetailService from '../../services/outwarddetail.sercice';

function AdminMaterialList() {


  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRecords, setSelectedRecords] = useState();
  const [outwardDate, setoutwardDate] = useState((moment(new Date())).format('YYYY-MM-DD'));
  const [allOutwardDetails, setAllOutwardDetails] = useState([]);

  interface selectRowType {
    mode: any;
    clickToSelect: boolean;  
    style: any;
    onSelect: any;
  }

  const selectRow: selectRowType = {
    mode: "radio",
    clickToSelect: true,
    style: { backgroundColor: '#c8e6c9' },
    onSelect: (row: any) => {
      setSelectedRecords(row.id);
    }
  }
  interface Article {
    options: any,
    currSizePerPage: any,
    onSizePerPageChange: any,
  }
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange
  }: Article) => (
    <div className="btn-group" role="group">
      {
        options.map((option: any) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn ${isSelect ? 'btn-secondary' : 'btn-red text-white'}`}
            >
              {option.text}
            </button>
          );
        })
      }
    </div>
  );

  interface optionsType {
    sizePerPageRenderer: any
  }
  const options: optionsType = {
    sizePerPageRenderer
  };
  const dateformater = (data: any, row: any) => {
    return  (moment(data)).format('DD/MM/YYYY')
  }
  const pagination = paginationFactory(options);
  const columns: ColumnDescription<selectRowType>[] = [
    { dataField: 'id', formatter: (cell, row, rowIndex, formatExtraData) => {  return rowIndex + 1;  }, text: 'id', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'reqID', text: 'Request Id', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'reqitemid', text: 'Request Item Id', align: 'left', headerClasses: 'left-aligned-header' } ,
    { dataField: 'ProductDescription', text: 'Product Description', align: 'left', headerClasses: 'left-aligned-header' }  ,
    { dataField: 'QuantityApproved', text: 'Quantity Approved', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'Branch', text: 'Branch', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'CourierName', text: 'Courier Name', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'ModeofDelivery', text: 'Mode Of Delivery', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'QuantityDispatched1', text: 'Quantity Dispatch', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'PODNo1', text: 'POD Number', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'DateofDispatch1', text: 'Date Of Dispatch', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'ChallanNo1', text: 'Challan Number', align: 'left', headerClasses: 'left-aligned-header' },
    { dataField: 'ChallanDate1', text: 'Challan Date', align: 'left', headerClasses: 'left-aligned-header' } ,
    { dataField: 'GeneratedDate', text: 'Generated Date', align: 'left', headerClasses: 'left-aligned-header' }  ,
    { dataField: 'Printer', text: 'Printer', align: 'left', headerClasses: 'left-aligned-header' }  ,
    { dataField: 'MailDate', text: 'Mail Date', align: 'left', headerClasses: 'left-aligned-header' }  ,
  ];
  //Table End
  const getAdminMaterialList = async () => {
    await OutwardDetailService.getAdminMaterialList(outwardDate).then(
      (data) => {
        console.log("data", data)
        if (data !== "") {
          setAllOutwardDetails(data);
        } else {
          setAllOutwardDetails([]);
        }
      }
    );
  }
  useEffect(() => {
    getAdminMaterialList();
  }, [outwardDate])
  useEffect(() => {
    setoutwardDate((moment(new Date())).format('YYYY-MM-DD'))
  }, [])

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false
  })

  const HandleDelete = () => {
    if (selectedRecords !== undefined) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          OutwardLogService.deleteoutwardLog(selectedRecords)
            .catch((error) => {
              console.log(error);
              console.log("server responding");

            })
          Swal.fire({
            title: "Deleted",
            icon: 'success',
            text: "Admin Material Outward Entry has been deleted",
          }).then(function () {
            window.location.reload()
          })
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            {
              title: "Cancelled",
              icon: 'error',
              text: "Admin Material Outward Entry is safe :)",
            }).then(function () {
              window.location.reload()
            }
            )
        }
      })
    }
  }

  const navigate = useNavigate();
  const EditDelivery = () => {
    if (selectedRecords !== undefined) {
      navigate('../adminmateriallist', { state: selectedRecords });
    }
  }

  const filteredData = Array.isArray(allOutwardDetails)
    ? allOutwardDetails.filter((selectedRecords) => {
      const values = Object.values(selectedRecords);
      return values.some(
        (value: unknown): boolean => {
          if (typeof value === 'string' || typeof value === 'number') {
            const stringValue = String(value).toLowerCase();
            return stringValue.includes(searchQuery.toLowerCase());
          }
          return false;
        }
      );
    })
    : [];
  return (
    <>
      <Outcontainerheader />
      <div style={{ margin: "0px" }}>
        <div style={{ display: "flex", flexDirection: "column", paddingTop: "1%" }}>
          <div className="container col-11" style={{paddingLeft : '0px'}}>
            <div className="themeColor" style={{ width: '100%' }} ><p style={{ marginLeft: "10px" }}> Admin Material Outward List</p></div>

            <div className='col-12' style={{ display: "flex", flexDirection: "row", width: "100%", height: "50px", justifyContent: "space-evenly", paddingTop: '1%' }}>

              <div className='margincard1itams' style={{ marginLeft: "10px" }}>
                <label> Out Date</label>
                <input className='margininutleft' type='Date' value={outwardDate} max={moment().format("YYYY-MM-DD")} name="logDateSearch" onChange={(e) => { setoutwardDate(e.target.value) }} />
              </div>
              <div className='margincard1itams'>
                <label >Branch Name :  {(localStorage.userDetails) ? JSON.parse(localStorage.userDetails).branchName : ""} </label>
              </div>
              <div className='col-6' style={{ display: "flex", height: "50px", justifyContent: "end" }}>
                <input
                  className='searchbar col-6'
                  type='text'
                  value={searchQuery}
                  placeholder='Search Here ...'
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div className="table-responsive tableContainer">
            <BootstrapTable rowStyle={{ fontSize: '15px', padding: '0px', whiteSpace: 'nowrap', width: '100%'}}
              keyField='id'
              striped
              hover
              condensed
              data={filteredData}
              columns={columns}
              // pagination={pagination}
              selectRow={selectRow}
              filter={filterFactory()}
              filterPosition="top"
              
            />
           </div>
          </div>
          <div className='row col-12 d-flex justify-content-center'>
            <Link to="../adminmaterial" className="btn2 col-2 col-sm-1"  > <i className="fa fa-plus" aria-hidden="true"></i>Add</Link>
            <button className="btn2 col-2 col-sm-1" onClick={EditDelivery}><i className="fa fa-edit"></i> Edit</button>
            <button className="btn2 col-2 col-sm-1" onClick={HandleDelete} ><i className="fa fa-trash"></i> Delete</button>
            <button className="btn2 col-2 col-sm-1" type="submit"> <i className="fa fa-sign-out" aria-hidden="true"></i> Close</button>

          </div>
        </div>
      </div>
    </>
  );
}

export default AdminMaterialList